// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"12250217","239":"c5f68727","246":"d1a18340","263":"aa661891","295":"a6b61771","328":"d1ea6a30","398":"dbbf97fb","453":"825386d9","676":"28514393","685":"7c2db9b2","732":"fda73a07","977":"30ebfe98"}[chunkId] + ".chunk.js";
};